module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAYAAAD/Rn+7AAAASklEQVRIx2M8J6j2n4EIYNR5i2EgAOOoA0cdOOpAKjlw8Tbv44PagYbvbjKMOnDUgaMOHMoOjBRjHNzFjNH7wV6TjDpw1IEj1IEAol5NN0OyZskAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ae.png
// module id = 763
// module chunks = 0